export default __webpack_public_path__ + "static/media/add-location.c89e71e0.svg";